import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { IPatient } from '../../interfaces/patient.interfaces';
import { PatientService } from '../../services/patient.service';

@Component({
    selector: 'app-create-pw',
    templateUrl: './create-pw.component.html',
    styleUrls: ['./create-pw.component.scss'],
    standalone: false,
})
export class CreatePwComponent implements OnInit {
    public loading = false;
    public patient!: IPatient;
    public exitForm = false; // Форма выхода

    public constructor(
        public dialogRef: MatDialogRef<CreatePwComponent>,
        private auth: AuthService,
        private alertService: AlertService,
        private ps: PatientService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.dialogRef.disableClose = true; // запрет закрытия окна (только командами)
    }

    public ngOnInit(): void {
        this.getPatientInfo();
    }

    /**
     * Получение данных из Кэша или сервера в зависимости от наличия
     */
    private getPatientInfo(): void {
        this.loading = true;
        this.ps.getServerPatientInfo$().subscribe({
            next: (info) => {
                this.patient = info;
                this.patient.birthDate = null;
                this.loading = false;
            },
            error: (err) => {
                this.loading = false;
            },
        });
    }

    public exit() {
        this.auth.logout();
        this.dialogRef.close();
    }

    // goToCreate(){
    //   this.ps.create_pw$()
    //     .subscribe(
    //       info => {
    //         if (!info) {
    //           this.alertService.error('Чтото пошло не так, попробуйте снова через 10 мин.');
    //         this.loading = false;
    //       }, err => {
    //         this.alertService.error(`Ошибка создания логина: ${err}`);
    //         this.loading = false;
    //       }
    //     );
    // }
}
